var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21967 6.20404C8.51256 5.91115 8.98744 5.91115 9.28033 6.20404L13.5303 10.454C13.8232 10.7469 13.8232 11.2218 13.5303 11.5147L9.28033 15.7647C8.98744 16.0576 8.51256 16.0576 8.21967 15.7647C7.92678 15.4718 7.92678 14.9969 8.21967 14.704L11.9393 10.9844L8.21967 7.26471C7.92678 6.97181 7.92678 6.49694 8.21967 6.20404Z",
    fill: "#0F172A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.0703b593a8218ff29170f3b763e77c81.svg";
export { ForwardRef as ReactComponent };